(function () {
  'use strict';

  /* The bar slides up once the hero's buy block leaves the viewport.
     If there is no hero on the page, it falls back to a scroll
     distance threshold. */

  var HERO_CTA_SELECTOR = '[data-cwc-db01-hero-cta]';
  var FALLBACK_OFFSET = 600;

  function initSection(sectionEl) {
    if (!sectionEl) return;

    var heroCta = document.querySelector(HERO_CTA_SELECTOR);

    function setVisible(isVisible) {
      sectionEl.classList.toggle('cwc_db01-sticky-cta--visible', isVisible);
    }

    if (heroCta && 'IntersectionObserver' in window) {
      if (sectionEl._cwcObserver) sectionEl._cwcObserver.disconnect();

      var observer = new IntersectionObserver(function (entries) {
        setVisible(!entries[0].isIntersecting);
      }, { threshold: 0 });

      observer.observe(heroCta);
      sectionEl._cwcObserver = observer;
      return;
    }

    if (sectionEl._cwcScrollHandler) {
      window.removeEventListener('scroll', sectionEl._cwcScrollHandler);
    }

    var onScroll = function () {
      setVisible(window.pageYOffset > FALLBACK_OFFSET);
    };

    sectionEl._cwcScrollHandler = onScroll;
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function initAllSections() {
    document.querySelectorAll('.cwc_db01-sticky-cta').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllSections);
  } else {
    initAllSections();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.cwc_db01-sticky-cta');
    if (section) initSection(section);
    // A hero reload replaces the observed element — rebind every bar.
    if (event.target.querySelector('.cwc_db01-hero')) initAllSections();
  });
})();
